export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "iban_title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["IBAN de remboursement"])},
        "iban_description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Coordonnées bancaires utilisées pour vous verser vos remboursements en cas de sinistre. Elles ne servent pas au paiement de vos cotisations."])}
      },
      "en": {
        "iban_title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Reimbursement IBAN"])},
        "iban_description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bank details used to pay out your claim reimbursements. They are not used to pay your premiums."])}
      }
    }
  })
}
